import React from 'react'
import { Link, useLocation } from "react-router-dom";
import Icons from '../myIcon/Icons';

export default function Menu({ isOpen, setIsOpen }) {
    const location = useLocation();

    // location value
    const locationData = {
        "resort-de-coracao-goa": {
            image: "/image/menu-goa.webp",
            name: "Goa",
            map: "https://maps.app.goo.gl/zRe8HjaScCxQmW7h7",
            address: "120/5 Gaura Vaddo Calangute, Goa- 403516",
            by: "Ria Hospitality",
            phone: "+91 955255 1356",
            email: "reservation@resortdecoracao.com",
            bookingLink: "https://www.swiftbook.io/inst/#home?propertyId=481MGhrFqip48IWZ2BdfBYNySqX3jg5Ng==&JDRN=Y",
            links: [
                { name: "Locations", path: "/" },
                { name: "Rooms & Suites", path: "/resort-de-coracao-goa/room-listing" },
                { name: "MICE & Events", path: "/resort-de-coracao-goa/meeting" },
                // { name: "Wellness & SPA", path: "/resort-de-coracao-goa/spa-wellness" },
                { name: "Gallery", path: "/resort-de-coracao-goa/gallery" },
                { name: "Dining", path: "/resort-de-coracao-goa/cuisine" },
            ]
        },

        "resort-de-coracao-rishikesh": {
            image: "/image/menu-rishikesh.webp",
            name: "Rishikesh",
            map: "",
            address: "Laxman Jhula Road Tapovan Rishikesh 249137 Uttarakhand",
            by: "Ria Vacations",
            phone: "+91 879624 1980",
            email: "reservation@resortdecoracao.com",
            bookingLink: "https://app.axisrooms.com/beV2/displaySearchResultV3.html?applicableDealId=0&room_number=0&login=false&allHotels=true&searcherId=56606855&searchNumber=1",
            links: [
                { name: "Locations", path: "/" },
                { name: "Rooms & Suites", path: "/resort-de-coracao-rishikesh/room-listing" },
                // { name: "MICE & Events", path: "/resort-de-coracao-rishikesh/meeting" },
                // { name: "Wellness & SPA", path: "/resort-de-coracao-rishikesh/spa-wellness" },
                // { name: "Gallery", path: "/resort-de-coracao-rishikesh/gallery" },
                { name: "Dining", path: "/resort-de-coracao-rishikesh/cuisine" },
            ]
        },

        "resort-de-coracao-corbett": {
            image: "/image/menu-corbett.webp",
            name: "Corbett",
            map: "https://maps.app.goo.gl/SM15UMhx2jkoRGRq8",
            address: "Khasra No- 67 Savalde west Dhela Road Ramnagar, Nainital Uttarakhand - 244715 (India)",
            by: "Ria Vacations",
            phone: "+91 753681 1188",
            email: "reservation@resortdecoracao.com",
            bookingLink: "https://www.swiftbook.io/inst/#home?propertyId=962MjsYOXZHJZLgLW4fVmXUGy1o5kn1R4GHQlUf4SKx6SGkIeEltbc5NQ==&JDRN=Y",
            links: [
                { name: "Locations", path: "/" },
                { name: "Rooms & Suites", path: "/resort-de-coracao-corbett/room-listing" },
                { name: "MICE & Events", path: "/resort-de-coracao-corbett/meeting" },
                { name: "Wellness & SPA", path: "/resort-de-coracao-corbett/spa-wellness" },
                { name: "Gallery", path: "/resort-de-coracao-corbett/gallery" },
                { name: "Dining", path: "/resort-de-coracao-corbett/cuisine" },
                { name: "Weddings", path: "/resort-de-coracao-corbett/wedding" },
                { name: "pet friendly", path: "/resort-de-coracao-corbett/pet-friendly" },
            ]
        }
    };

    // Default value
    const defaultData = {
        image: "/image/menu-default.webp",
        name: "Corbett",
        map: "https://maps.app.goo.gl/SM15UMhx2jkoRGRq8",
        address: "Khasra No- 67 Savalde west Dhela Road Ramnagar, Nainital Uttarakhand -244715 (India)",
        by: "Ria Vacations",
        phone: "+91 929292 8787",
        email: "reservation@resortdecoracao.com",
        bookingLink: "https://www.swiftbook.io/inst/#group?groupId=381M25HpcJdio6EBB8BhhWNjE2NzE=&JDRN=Y",
        links: [
            { name: "Goa", path: "/resort-de-coracao-goa" },
            { name: "Jim Corbett", path: "/resort-de-coracao-corbett" },
            { name: "Rishikesh", path: "/resort-de-coracao-rishikesh" },
        ]
    };

    // slug detect
    const currentSlug = Object.keys(locationData).find(slug =>
        location.pathname.includes(slug)
    );

    const currentData = locationData[currentSlug] || defaultData;

    // default detect
    const isDefault = !currentSlug;

    return (
        <>
            <section className={isOpen ? "mobilemenu-area open-menu" : "mobilemenu-area close-menu"}>
                <div className="mainmenu-wrapper">
                    <div className="menu-leftside">
                        <div className="menu-toplinks">
                            <button className="menu-close-btn" onClick={() => { setIsOpen(false); }} aria-label="Close menu"><Icons name="cross" /></button>

                            <Link to={currentData.bookingLink} target="_blank"  className="default-btn color-btn" onClick={() => { setIsOpen(false); }}><img src="/image/calender.webp" alt="calender"/> Book My Stay</Link>
                        </div>

                        <div className={`menu-mainlink ${isDefault ? "default-menulink" : ""}`}>
                            <ul>
                                {currentData.links.map((item, index) => (
                                    <li key={index}>
                                        <Link to={item.path} onClick={() => setIsOpen(false)}>
                                            {item.name}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <div className="menu-address">
                            {!isDefault && (
                            <>
                                <span>{currentData.name} - </span>
                                <a href={currentData.map} target="_blank" rel="noreferrer" className="line-button">View on map</a>
                                <p>{currentData.address}</p>
                                <small>-by {currentData.by}</small>
                            </>
                            )}

                            <ul>
                                <li>
                                    <Link to={`tel:${currentData.phone}`}>
                                        <img src="/image/menu-phone.webp" alt="phone" />
                                        {currentData.phone}
                                    </Link>
                                </li>

                                <li>
                                    <Link to={`mailto:${currentData.email}`}>
                                        <img src="/image/menu-email.webp" alt="email" />
                                        {currentData.email}
                                    </Link>
                                </li>
                            </ul>
                           {/* <img src="/image/tripadvisor-ratting-old.webp" className="menu-ratting" alt="tripadvisor" /> */}
                            <img src="/image/allsite-ratting.webp" className="menu-ratting" alt="ratting" />
                        </div>
                        
                        <div className="menu-bottomlink">
                            <ul className="footer-social">
                                <li><Link to="https://www.facebook.com/ResortDeCoracaoofficial/" target="_blank" aria-label="Facebook"><Icons name="facebook" /></Link></li>
                                <li><Link to="https://www.instagram.com/resortdecoracao/" target="_blank" aria-label="instagram"><Icons name="instagram" /></Link></li>
                                <li><Link to="https://www.linkedin.com/company/resort-de-coração" target="_blank" aria-label="linkedin"><Icons name="linkedin" /></Link></li>
                                <li><Link to="https://web.whatsapp.com/send?phone=+919292928787&_ga=2.261651789.1393896926.1665567039-1858394251.1662704687" target="_blank" aria-label="whatsapp"><Icons name="whatsapp" /></Link></li>
                                <li><Link to="https://www.youtube.com/channel/UCjgc3pXH7KYjPdsDCKnD_vw" target="_blank" aria-label="youtube"><Icons name="youtube" /></Link></li>
                            </ul>

                            <ul className="menu-otherlink">
                                <li><Link to="about-us" onClick={() => { setIsOpen(false); }}>Our Story</Link></li>   
                                <li><Link to="/blog" onClick={() => { setIsOpen(false); }}>Blogs</Link></li>  
                                <li><Link to="/offer-listing" onClick={() => { setIsOpen(false); }}>Exclusive Offers</Link></li>   
                                <li><Link to="/contact-us" onClick={() => { setIsOpen(false); }}>Contact</Link></li>
                            </ul>
                        </div>
                    </div>

                    <div className="menu-rightside">
                        <div>
                            <img src={currentData.image} className="img-responsive" alt={currentData.name}/>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}